<ng-container *ngIf="initialized">

  <p-button [disabled]="disabled || busy"
            (click)="handleButtonClick()"
            [styleClass]="class"
            [label]="label"
            [type]="type"
            [pTooltip]="tooltip"
            [severity]="severity"
            [outlined]="outlined"
            [icon]="uiIcon"
            [iconPos]="iconPos">
  </p-button>

</ng-container>
